import React, { Component } from "react";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { withRouter } from "react-router";
import { withTranslation } from "react-i18next";

export class MenuLink extends Component {
  render() {
    return (
      <ListItem button onClick={this.onClick}>
        <ListItemIcon>
          <span className="material-icons">{this.props.portlet.icon}</span>
        </ListItemIcon>
        <ListItemText primary={this.props.t(this.props.portlet.title)} />
      </ListItem>
    );
  }

  onClick = () => {
    this.props.history.push(JSON.parse(this.props.portlet.parameters).route);
  };
}

export default withRouter(withTranslation()(MenuLink));
